"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Return the given number if in range, otherwise return the nearest value in
 * range.
 *
 * @Example
 *    clamp(1, 2, 3)
 *    //=> 2
 *
 *    clamp(1, 3, 2)
 *    //=> 2
 *
 *    clamp(2, 1, 3)
 *    //=> 2
 */
function clamp(min, given, max) {
    if (given > max) {
        return max;
    }
    if (given < min) {
        return min;
    }
    return given;
}
exports.clamp = clamp;
//# sourceMappingURL=clamp.js.map